module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_vm._v("ABBREVIATIONS")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CSCO")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Corpus Scriptorum Christianorum Orientalium. Leuven: Peeters, 1903–.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("GEDSH")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Gorgias Encyclopedic Dictionary of the Syriac Heritage")]), _vm._v(". Edited by Sebastian P. Brock, Aaron M. Butts, George A. Kiraz, and Lucas Van Rompay. Piscataway, NJ: Gorgias, 2011 (online at "), _c('a', {
    attrs: {
      "href": "http://gedsh.bethmardutho.org",
      "target": "_blank"
    }
  }, [_vm._v("http://gedsh.bethmardutho.org")]), _vm._v(").")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("MH")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Matenagirk‘ Hayoc‘")]), _vm._v(" ("), _c('em', [_vm._v("Armenian Classical Authors")]), _vm._v("). Vols. 1–15: Antelias, Lebanon, 2003–2010; vols. 16–21: Erevan, Armenia, 2012– (some volumes online at "), _c('a', {
    attrs: {
      "href": "https://matenadaran.am",
      "target": "_blank"
    }
  }, [_vm._v("https://matenadaran.am")]), _vm._v(").")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("RIÉ")])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Recueil des inscriptions de l’Éthiopie des périodes pré-axoumite et axoumite")]), _vm._v(". Vol. 1, "), _c('em', [_vm._v("Les document")]), _vm._v("s, and Vol. 2, "), _c('em', [_vm._v("Les planches")]), _vm._v(", by É. Bernand, A. J. Drewes, and R. Schneider. Paris: Boccard, 1991. Vol. 3, "), _c('em', [_vm._v("Traductions et commentaires")]), _vm._v(", part A, "), _c('em', [_vm._v("Les inscriptions grecques")]), _vm._v(", by É. Bernand. Paris: Boccard, 2000. Vol. 3, "), _c('em', [_vm._v("Traductions et commentaires")]), _vm._v(", part B, "), _c('em', [_vm._v("Les inscriptions sémitiques")]), _vm._v(", by A. J. Drewes, revised by Manfred Kropp, edited by Manfred Kropp and Harry Stroomer. Äthiopistische Forschungen 85/De Goeje Fund 34; Wiesbaden: Harrassowitz, 2019.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ac41552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbreviations.vue
// module id = 75
// module chunks = 0